import React from 'react';
import { NpsBotaoStyled } from './nps-botao.component.style';
export var NpsBotao = function (_a) {
    var variante = _a.variante, _b = _a.sobreMarca, sobreMarca = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? 'button' : _c, disabled = _a.disabled, loading = _a.loading, onClick = _a.onClick, children = _a.children;
    return (React.createElement(NpsBotaoStyled, { variant: "primary", expanded: true, type: type, disabled: disabled, loading: loading, onClick: onClick, "$variante": variante, "$sobreMarca": sobreMarca, "$carregando": !!loading }, children));
};
